<template>
  <div class="mt-15">
    <AutoForm
      class="autoForm contactPartner"
      :layout="layout"
      :model="entity"
      @submit="onSubmit"
      ref="form"
    />
    <v-text-field
      class="checkBotField pt-0"
      v-model="email"
    ></v-text-field>
    <div class="d-flex justify-center text-center mt-5">
      <ReCaptchaSubmit @onSubmit="onSubmit"/>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import AutoForm from "@/components/Forms/AutoForm";
import FormPartnership from "@/forms/FormPartnership";
import ContactService from "@/services/ContactService";
import ReCaptchaSubmit from "@/components/Contact/ReCaptchaSubmit";
export default {
  name: "PartnershipForm",
  components: {
    VueRecaptcha,
    AutoForm,
    FormPartnership,
    ReCaptchaSubmit
  },
  data() {
    return {
      dialog: true,
      errorText: this.$gettext("Le captcha de vérification est obligatoire"),
      dialogSendContact: false,
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      isValidateRecaptcha: false,
      isShowMessage: false,
      entity: Object.assign({}, FormPartnership.defaultEntity),
      email: ''
    };
  },
  computed: {
    layout() {
      return FormPartnership.layout(this.entity);
    },
  },
  methods: {
    async onSubmit() {
      if (this.$refs.form.validate()) {
        const result = await ContactService.sentContactPartner(this.entity)
        if (result.error) {
          this.$toast.alert(result.error.message);
        } else {
          this.openDialog()
        }
      }
    },
    async openDialog() {
      const toggle = await this.$store.state.toggle.dialogConfirm.open(
        null,
        this.$gettext('Thank you, your request has reached us successfully.'),
        { color: "success", width: 500 },
        true,
        true,
        true
      );
      this.$router.push({name: 'homepage'})
    }
  }
}
</script>